import axios from 'axios'
import config from '@/config'
import { getChatDomain } from '../utils/helpers'
/** getEligibility request check if widget should show or not for specific pages
 * @returns {Promise<AxiosResponse<any>>}
 */
let DOMAIN = config.THERMO_DOMAIN
let EligibilityUrl = DOMAIN + config.TF_API_ELIGIBILITY
let agentAvailabilityUrl = DOMAIN + config.TF_API_AGENT_AVAILABILITY
let agentAvailabilityUrlV2 = DOMAIN + config.TF_API_AGENT_AVAILABILITY_V2
let agentInformationUrl = DOMAIN + config.TF_API_MEDALIA_AVALABILITY
let DOMAIN_USER = config.THERMO_ROOT_DOMAIN
let userDetailsURL = config.TF_API_USER_DETAILS
let getSearchResultsURL = DOMAIN + config.TF_CONNEX_API_GET_SEARCH_RESULTS
let agentAvailabilityUrlFS = ' '
const hostName = getChatDomain()

if (hostName.includes('fishersci')) {
  DOMAIN = config.FISHER_DOMAIN
  EligibilityUrl = DOMAIN + config.FS_API_ELIGIBILITY
  agentInformationUrl = DOMAIN + config.FS_API_MEDALIA_AVALABILIT
  agentAvailabilityUrlFS = DOMAIN + config.FS_API_AGENT_AVAILABILITY
} else if (hostName.includes('ampliseq')) {
  userDetailsURL = config.TF_API_AMPLISEQ_USER_DETAILS
}

export function getEligibility (params) {
  const requestParam = window.location.pathname + window.location.search + window.location.hash
  return axios
    .get(EligibilityUrl, {
      params: {
        url: requestParam,
        ...params
      },
       withCredentials: true
    })
}

export function getAgentAvailability (params) {
  const requestParam = window.location.pathname + window.location.search + window.location.hash
  return axios
    .get(agentAvailabilityUrl, {
      params: {
        url: requestParam,
        ...params
      }
    })
  }

export function getAgentAvailabilityV2 (params, agents) {
  const eligibleAgents = agents.join()
  return axios
    .get(agentAvailabilityUrlV2, {
      params: {
        agents: eligibleAgents,
        ...params
      }
      // withCredentials: true
    })
}
export function getAgentAvailabilityfs (params) {
  return axios.get(agentAvailabilityUrlFS, {
    params: {
      ...params
    }
    // withCredentials: true
  })
}
// 1. Get the agent information from Redis cache by chatSessionId or uniqueChatId
export function getAgentInformation (id) {
  const url = `${agentInformationUrl}/${id}`
  return axios
    .get(url, {}, {
      params: {
        url: url
      }
      // withCredentials: true
    })
}

export function getSearchResults (params) {
  const url = getSearchResultsURL
  return axios
    .get(url, {
      params: {
        query: params.search,
        language: params.language,
        countryCode: params.countryCode
      }
    })
}

export function getUserDetails () {
  return axios.get(userDetailsURL, {})
}
